import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter,Outlet} from "react-router-dom";
import Menu from './components/Menu';
import { AccessTokenProvider } from './AccessTokenProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
   <AccessTokenProvider>
   <Menu />
    <App>
    <Outlet />
    </App>
  </AccessTokenProvider>
  </BrowserRouter>
);
